import { render, staticRenderFns } from "./codes-tab.vue?vue&type=template&id=9b6a82a2&scoped=true"
import script from "./codes-tab.vue?vue&type=script&lang=js"
export * from "./codes-tab.vue?vue&type=script&lang=js"
import style0 from "./codes-tab.vue?vue&type=style&index=0&id=9b6a82a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6a82a2",
  null
  
)

export default component.exports